import { FormInstance, Space } from 'antd';
import { MouseEvent } from 'react';

import { useTranslation } from 'react-i18next';
import CustomButton from '../buttons/custom-button/custom-button';

interface Props {
  form: FormInstance;
  formId: string;
  clearFilters?: () => void;
}
const FormActions = ({ form, formId, clearFilters }: Props): JSX.Element => {
  const { t } = useTranslation('common');

  const onFilter = (event: MouseEvent) => {
    event.preventDefault();
    form.submit();
  };
  const onClearFilter = () => {
    if (clearFilters) {
      clearFilters();
    }
    form.resetFields();
  };

  return (
    <Space size={18}>
      <CustomButton key="submit" onClick={onFilter} htmlType="submit" form={formId}>
        {t('action.filter')}
      </CustomButton>
      <CustomButton key="clearFilters" type="textBg" onClick={onClearFilter}>
        {t('action.clearFilters')}
      </CustomButton>
    </Space>
  );
};
export default FormActions;
